import { render, staticRenderFns } from "./Parametre.vue?vue&type=template&id=3064742e&"
import script from "./Parametre.vue?vue&type=script&lang=js&"
export * from "./Parametre.vue?vue&type=script&lang=js&"
import style0 from "./Parametre.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports